// extracted by mini-css-extract-plugin
module.exports = {"calc_desc":"style_calc_desc__rLWZo","calc_desc__title":"style_calc_desc__title__3vGYN","calc_desc__text":"style_calc_desc__text__2Qz9I"};